export function shouldShowWebToCaseMaintenance(sfAvailability: unknown): boolean {
    if (sfAvailability == null || typeof sfAvailability !== 'object') {
        return false;
    }
    const available = (sfAvailability as { available?: unknown }).available;
    if (available === false) {
        return true;
    }
    return false;
}
